import { render, staticRenderFns } from "./Catagory.vue?vue&type=template&id=48009aa9&scoped=true&"
import script from "./Catagory.vue?vue&type=script&lang=js&"
export * from "./Catagory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48009aa9",
  null
  
)

export default component.exports